import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useHashView } from './useHashView';
import { IN_SCOPE_PATH_FOR, isPathInScope, parseShareUrl } from './shareLinkConfig';
import { setHashViewBlocksHandoff } from 'global/utils/nativeShell';

// When a hashed view is active, the user is locked to the single shared resource.
// This wraps the normal route Switch and redirects any attempt to navigate
// elsewhere back to the in-scope path. The /share/:hash redemption route is
// allowed through so redemption can complete on a fresh page load.
export default function HashViewGuard({ children }) {
  const { active, scope, hash } = useHashView();
  const location = useLocation();

  useEffect(() => {
    setHashViewBlocksHandoff(active);
    return () => setHashViewBlocksHandoff(false);
  }, [active]);

  if (!active) return children;

  // Allow the redemption route to render so it can complete its redirect.
  if (parseShareUrl(location)) return children;

  // A message PDF link stays on its share URL until the file is ready. There is
  // no other in-app page for that hash.
  if (scope?.kind === 'message' && hash && scope.id) {
    return <Redirect to={`/share/${encodeURIComponent(hash)}/message/${encodeURIComponent(scope.id)}`} />;
  }

  if (scope && !isPathInScope(location.pathname, scope)) {
    return <Redirect to={IN_SCOPE_PATH_FOR(scope)} />;
  }

  return children;
}
